import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";


import BottomFooter from "../components/BottomFooter";

import Contact from "../components/Contact";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import ContactBanner from "../components/ContactBanner";
import ShippingOne from "../components/ShippingOne";
const ContactPage = () => {
  return (
    <>
    <HeaderOne/>
    <ContactBanner/>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

    

     

      {/* Contact */}
      <Contact />

    <ShippingOne/>

      <FooterOne/>
<BottomFooter/>
      
    </>
  );
};

export default ContactPage;
